/** Guards the company pages, remembering where the visitor was headed. */

import { Navigate, useLocation } from 'react-router-dom';
import type { ReactNode } from 'react';

import { useAuth } from '../lib/auth-context';

export function RequireAuth({ children }: { readonly children: ReactNode }): ReactNode {
  const auth = useAuth();
  const location = useLocation();

  if (!auth.isSignedIn) {
    const next = `${location.pathname}${location.search}`;
    return <Navigate to={`/auth?next=${encodeURIComponent(next)}`} replace />;
  }
  return <>{children}</>;
}
